/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PollSettingsScale = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PollSettingsScale model module.
   * @module model/PollSettingsScale
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PollSettingsScale</code>.
   * @alias module:model/PollSettingsScale
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>PollSettingsScale</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PollSettingsScale} obj Optional instance to populate.
   * @return {module:model/PollSettingsScale} The populated <code>PollSettingsScale</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('PollID')) {
        obj['PollID'] = ApiClient.convertToType(data['PollID'], 'Integer');
      }
      if (data.hasOwnProperty('Value')) {
        obj['Value'] = ApiClient.convertToType(data['Value'], 'Integer');
      }
      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('TitleFI')) {
        obj['TitleFI'] = ApiClient.convertToType(data['TitleFI'], 'String');
      }
      if (data.hasOwnProperty('TitleEN')) {
        obj['TitleEN'] = ApiClient.convertToType(data['TitleEN'], 'String');
      }
      if (data.hasOwnProperty('TitleSE')) {
        obj['TitleSE'] = ApiClient.convertToType(data['TitleSE'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} PollID
   * @default 0
   */
  exports.prototype['PollID'] = 0;
  /**
   * @member {Integer} Value
   * @default 0
   */
  exports.prototype['Value'] = 0;
  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {String} TitleFI
   * @default ''
   */
  exports.prototype['TitleFI'] = '';
  /**
   * @member {String} TitleEN
   * @default ''
   */
  exports.prototype['TitleEN'] = '';
  /**
   * @member {String} TitleSE
   * @default ''
   */
  exports.prototype['TitleSE'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


